module.exports = __webpack_public_path__ + "static/img/city08.f7df670.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/city08.jpg
// module id = npfK
// module chunks = 0